const ID_SITUACAO_SOLICITACAO_RASCUNHO = 1;
const SITUACAO_SOLICITACAO_RASCUNHO = {
	id: ID_SITUACAO_SOLICITACAO_RASCUNHO,
	nome: 'Rascunho'
}

const ID_SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA = 2;
const SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA = {
	id: ID_SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA,
	nome: 'Aguardando assinatura'
}

const ID_SITUACAO_SOLICITACAO_EM_ANALISE_CEDENTE = 3;
const SITUACAO_SOLICITACAO_EM_ANALISE_CEDENTE = {
	id: ID_SITUACAO_SOLICITACAO_EM_ANALISE_CEDENTE,
	nome: 'Em análise pelo cedente dos dados'
}

const ID_SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA = 4;
const SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA = {
	id: ID_SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA,
	nome: 'Em análise pelo gestor da plataforma'
}

const ID_SITUACAO_SOLICITACAO_REJEITADA_CEDENTE = 5;
const SITUACAO_SOLICITACAO_REJEITADA_CEDENTE = {
	id: ID_SITUACAO_SOLICITACAO_REJEITADA_CEDENTE,
	nome: 'Rejeitada pelo cedente dos dados'
}

const ID_SITUACAO_SOLICITACAO_DEFERIDA_SEM_VOLUMETRIA = 6;
const SITUACAO_SOLICITACAO_DEFERIDA_SEM_VOLUMETRIA = {
	id: ID_SITUACAO_SOLICITACAO_DEFERIDA_SEM_VOLUMETRIA,
	nome: 'Deferida sem volumetria'
}

const ID_SITUACAO_SOLICITACAO_DEFERIDA = 7;
const SITUACAO_SOLICITACAO_DEFERIDA = {
	id: ID_SITUACAO_SOLICITACAO_DEFERIDA,
	nome: 'Deferida'
}

const ID_SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA = 8;
const SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA = {
	id: ID_SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA,
	nome: 'Rejeitada pelo gestor da plataforma'
}

const ID_SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA = 9;
const SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA = {
	id: ID_SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA,
	nome: 'Configurando pasta segura'
}

	const ID_SITUACAO_SOLICITACAO_LIBERADA_PROCESSAMENTO = 2;
	const SITUACAO_SOLICITACAO_LIBERADA_PROCESSAMENTO = {
	id: ID_SITUACAO_SOLICITACAO_LIBERADA_PROCESSAMENTO,
	nome: 'Liberada para processamento'
}

const ID_SITUACAO_SOLICITACAO_EM_PROCESSAMENTO = 3;
const SITUACAO_SOLICITACAO_EM_PROCESSAMENTO = {
	id: ID_SITUACAO_SOLICITACAO_EM_PROCESSAMENTO,
	nome: 'Em processamento'
}

const ID_SITUACAO_SOLICITACAO_PROCESSADA = 4;
const SITUACAO_SOLICITACAO_PROCESSADA = {
	id: ID_SITUACAO_SOLICITACAO_PROCESSADA,
	nome: 'Processada'
}

export {
	ID_SITUACAO_SOLICITACAO_RASCUNHO, SITUACAO_SOLICITACAO_RASCUNHO,
	ID_SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA, SITUACAO_SOLICITACAO_AGUARDANDO_ASSINATURA,
	ID_SITUACAO_SOLICITACAO_EM_ANALISE_CEDENTE, SITUACAO_SOLICITACAO_EM_ANALISE_CEDENTE,
	ID_SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA, SITUACAO_SOLICITACAO_EM_ANALISE_GESTOR_PLATAFORMA,
	ID_SITUACAO_SOLICITACAO_REJEITADA_CEDENTE, SITUACAO_SOLICITACAO_REJEITADA_CEDENTE,
	ID_SITUACAO_SOLICITACAO_DEFERIDA_SEM_VOLUMETRIA, SITUACAO_SOLICITACAO_DEFERIDA_SEM_VOLUMETRIA,
	ID_SITUACAO_SOLICITACAO_DEFERIDA, SITUACAO_SOLICITACAO_DEFERIDA,
	ID_SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA, SITUACAO_SOLICITACAO_REJEITADA_GESTOR_PLATAFORMA,
	ID_SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA, SITUACAO_SOLICITACAO_CONFIGURANDO_PASTA_SEGURA,
	ID_SITUACAO_SOLICITACAO_LIBERADA_PROCESSAMENTO,SITUACAO_SOLICITACAO_LIBERADA_PROCESSAMENTO,
	ID_SITUACAO_SOLICITACAO_EM_PROCESSAMENTO, SITUACAO_SOLICITACAO_EM_PROCESSAMENTO,
	ID_SITUACAO_SOLICITACAO_PROCESSADA, SITUACAO_SOLICITACAO_PROCESSADA,
 }